import { render, staticRenderFns } from "./ArticleModalView.vue?vue&type=template&id=0153cfca&"
import script from "./ArticleModalView.vue?vue&type=script&lang=js&"
export * from "./ArticleModalView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleModalView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports